import React, { useEffect } from "react";
import { Switch, Redirect, RouteComponentProps, useLocation, useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";
import { appPaths, PageTitleSetter, appPageTitles } from "../../Common";
import { ProtectedRoute, useLoggedInUser } from "../../Auth";
import { setBreadcrumbs } from "../../Startup/Actions/StartupActions";
import { breadcrumbService } from "../../Layout";
import { breadcrumbsMap } from "../breadcrumbsMap";
import OverviewFeedbackListContainer from "./OverviewFeedbackListContainer";

const OverviewRoutes: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useLoggedInUser();

  const resolveVariable = async (key: string, variables: Map<string, string>) => {
    return key;
  };

  const setMyBreadcrumbs = () => {
    const crumbs = breadcrumbService.createBreadcrumbs(
      location.pathname,
      breadcrumbsMap,
      resolveVariable
    );
    dispatch(setBreadcrumbs(crumbs));
  };

  useEffect(() => {
    setMyBreadcrumbs();
  }, [user, location.pathname]);

  return (
    <>
      <PageTitleSetter title={appPageTitles.general} />
      <Switch>
        <ProtectedRoute
          exact
          path={appPaths.overview.root}
          component={OverviewFeedbackListContainer}
        />
        <Redirect to={appPaths.notFound} />
      </Switch>
    </>
  );
};

export default OverviewRoutes;
